import { AxiosRequestConfig } from "axios";

import { HEADERS } from "@utils/constants";

const isRetryRequest = (requestConfig: AxiosRequestConfig | undefined): boolean => !!requestConfig?.headers?.[HEADERS.RETRY];

export default isRetryRequest;
